import type { ComputedRef } from 'vue'
import type { AppTextColor } from '@shared/ui/typography'
import type { AppBadgeProps } from '../types/interfaces'

interface AppBadgeOptions {
  props: AppBadgeProps
}

interface AppBadgeReturn {
  textColor: ComputedRef<AppTextColor>
}

export const useAppBadge = ({ props }: AppBadgeOptions): AppBadgeReturn => {
  const textColor = computed<AppTextColor>(() => `${props.color}-600` as AppTextColor)

  return {
    textColor,
  }
}
